import script from "./leads-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./leads-modal.vue?vue&type=script&setup=true&lang=js"

import "./leads-modal.vue?vue&type=style&index=0&id=3bcb4c86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bcb4c86"]])

export default __exports__